<template lang="pug">
v-container(fluid pa-0 ma-0)
  v-row(align="center" class="tw-py-0 tw-my-0")
    v-col(cols="10")
      v-row(dense)
        v-col(cols="6" class="tw-bg-white tw-rounded-t-md tw-shadow-md")
          v-tabs(
            v-model="tab"
            grow
            background-color="white"
            :ripple="false"
            color="orange darken-4"
            slider-color="orange darken-4"
          )
            v-tab(:ripple="false")
              span(class="font-poppins text-none") Buy
            v-tab(:ripple="false")
              span(class="font-poppins text-none") Rent
      v-row(dense class="tw--mt-3")
        v-col(cols="12" class="tw-bg-white tw-rounded-tr-md tw-shadow-md tw-rounded-b-md pa-5")
          v-row(no-gutters class="")
            v-col
              v-text-field(outlined hide-details rounded label="What are you looking for?")
          v-row(no-gutters class="")
            v-col(cols="12")
              v-btn(
                block
                elevation="0"
                rounded
                color="orange darken-4"
                @click=""
                x-large
              )
                v-icon mdi mdi-magnify
                span(class="font-poppins tw-capitalize pl-1") Search
</template>
<script>
export default {
  data() {
    return {
      tab: 0,
    };
  },
};
</script>
